<template>
  <div class="menu_nav_w bc_0983CC">
    <div
      v-for="navMenu in renderMenus"
      :key="navMenu.id"
      class="float_l"

    >
      <!-- 最后一级菜单 -->
      <el-menu-item
        v-if="!navMenu.children"
        :key="navMenu.id"
        @click="onMenuClick(navMenu)"
      >
        <img :src="navMenu.icon" alt="" />
        <span slot="title">{{ navMenu.name }} </span>
      </el-menu-item>

      <!-- 此菜单下还有子菜单 -->
      <el-submenu
        v-if="navMenu.children && navMenu.children.length"
        :key="navMenu.id"
        :index="navMenu.name"
        @click.native="onParentClick(navMenu)"
      >
        <template slot="title">
          <img :src="navMenu.icon" alt="" />
          <span>{{ navMenu.name }} </span>
        </template>
        <!-- 递归 -->
        <MenuNav :menus="navMenu.children" />
      </el-submenu>
    </div>
  </div>
</template>

<script>
import MenuNav from "@/components/base/MenuNav.vue";
import Cookies from "js-cookie";
import { mapGetters } from "vuex";
import bus from "@/utils/bus";


export default {
  name: "MenuNav",
  components: {
    MenuNav,
  },
  props: {
    menus: {
      type: Array,
      default: () => [],
    },
    exclude:{
      type:String,
      default:''
    }  // 剔除不包含
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters(["siteInfo"]),
    excludes(){
      return this.exclude.split(',')
    },
    renderMenus(){
      let result = []
      function repeat(children){
        return children.filter(item=>{
          if(this.excludes.includes(item.code)) return false
          if(item.children && item.children.length){
            item.children = repeat.call(this,item.children)
          }
          return true
        })
      }
      result = repeat.call(this,this.menus)
      return result
    },
  },

  created() {},
  methods: {
    //栏目目录点击
    onParentClick(menuItem) {
      // 其他
      if(menuItem.kind === 0){
        this.$router.push(menuItem.nodeModel.route)
      }
      // 文章1 文件2
      if([1,2].includes(menuItem.kind)){
        let firstItem = null
        if(menuItem.children && menuItem.children.length){
          firstItem = menuItem.children[0]
          this.$router.push(firstItem.nodeModel.route + `/${firstItem.id}`)
        }else{
          this.$router.push(menuItem.nodeModel.route + `/${menuItem.id}`)
        }
      }
    },
    // 菜单点击
    onMenuClick(menuItem) {
      if(['bigdata'].includes(menuItem.code)){
        window.open(location.origin + menuItem.nodeModel.route,'_blank')
        return
      }
      // 其他
      if(menuItem.kind === 0){
        this.$router.push(menuItem.nodeModel.route)
      }
      // 文章1 文件2
      if([1,2].includes(menuItem.kind)){
        this.$router.push(menuItem.nodeModel.route + `/${menuItem.id}`)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.my_nav {
  .menu_nav_w {
    overflow: hidden;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .el-menu-item,
    ::v-deep .el-submenu__title {
      font-size: 16px;
      color: #fff !important;

      & img {
        margin: 0 10px 0 0;
      }
      i {
        display: none; //隐藏默认的箭头图标
      }
      &:focus,
      &:hover {
        background: #0772b2 !important;
      }
    }
  }
}

::v-deep .el-submenu__icon-arrow {
  position: static;
  vertical-align: middle;
  margin-left: 8px;
  margin-top: -3px;
}

::v-deep .el-menu-item {
  padding: 0 20px !important;

  color: #fff !important;
  background-color: rgba($color: #0983cc, $alpha: 1) !important;
  &:hover {
    background-color: #fff !important;
    color: #0983cc !important;
  }
}
</style>
